import React, { useState, useEffect, useRef } from 'react';
import {BrowserRouter as Router, Route, Link, Routes} from 'react-router-dom';

import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { Landing } from './components/Landing'

import { Room1 } from './components/Room1'
import { Room2 } from './components/Room2'
import { Room3 } from './components/Room3'
import { Room4 } from './components/Room4'
import { Room5 } from './components/Room5'
import { Room6 } from './components/Room6'
import { Room7 } from './components/Room7'
import { Room8 } from './components/Room8'
import { Room9 } from './components/Room9'

import { Debug } from './components/Debug'
import { Player } from './components/Player';
import { Time } from "./components/Time"
import { Come } from "./components/Come"
import { Regolamento } from "./components/Regolamento"
import { Crediti } from "./components/Crediti"
import { Contatti } from "./components/Contatti"
import { Scopri } from "./components/Scopri"
import { Classifica } from "./components/Classifica"


import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/scss/App.scss";

import { startGame, updateState, checkState, setNickname, validateTicket } from './services/UserService'

const App = () => {
  // let audio = new Audio("/mp3/sound.mp3")

  //const [songs, setSongs] = useState(songsdata);
  // const [currentSong, setCurrentSong] = useState(songsdata[1]);

  let [state, setState] = React.useState({
    uuid: '',
    waitingApi: false,
    room: 0,
    step: 0,
    stepnow: 0,
    answer: '',
    answer2: '',
    answer3: '',
    answer4: '',
    answerfeedback: false, // wrong right
    ticket: '', // vivaticket code o manually insert code
    nick: '',
    loginfeedback: false,
    helpstate: 0,
    helpopen: 0,
    penality: 0,
    helpsused: [[0,0,0],[0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0],[0,0,0,0,0,0],[0,0,0],[0,0,0]],
    starttime: 0,
    endtime: 0
  })

  const uuidRef = useRef(state.uuid);
  const waitRef = useRef(state.waitingApi);
  const intervalRef = useRef(null)

  uuidRef.current = state.uuid;
  waitRef.current = state.waitingApi;

  const answers= {
    room1: ["05"],
    room2a: ["MUSEODELRISORGIMENTO","museodelrisorgimento"],
    room2b: ["ELSA","elsa"],
    room2c: ["ZODIACCANCERNECKLACE","zodiaccancernecklace"],
    room3a: ["VITTORIOEMANUELEIII","vittorioemanueleiii"],
    room3b: [["10"],["20"],["250"],["260"]],
    room4a: ["imu", "IMU"],
    room4b: [["computer di bordo in tilt", "COMPUTER DI BORDO IN TILT", "COMPUTER DI BORDO IN TILT.", "computer di bordo in tilt."], ["sgancio paracadute", "SGANCIO PARACADUTE", "SGANCIO PARACADUTE.", "sgancio paracadute."], ["accensione retrorazzi per 3 secondi", "ACCENSIONE RETRORAZZI PER 3 SECONDI", "ACCENSIONE RETRORAZZI PER 3 SECONDI.", "accensione retrorazzi per 3 secondi."], ["schianto", "SCHIANTO", "SCHIANTO.", "schianto."]],
    room5: ["missioniautomatiche", "MISSIONIAUTOMATICHE"],
    room6: ["fratellanza!", "FRATELLANZA!"]
  }

  const singleAnswers= ["room1", "room2a", "room2b", "room2c", "room3a", "room4a", "room5", "room6"];
  const multipleAnswers= ["room3b", "room4b"];

  const handleChangeAnswer = (e, i = 1) => {
    e.persist();
    let r1 = (i === 1) ? e.target.value : state.answer;
    let r2 = (i === 2) ? e.target.value : state.answer2;
    let r3 = (i === 3) ? e.target.value : state.answer3;
    let r4 = (i === 4) ? e.target.value : state.answer4;

    setState(prevState => ({
      ...prevState,
      answer: r1,
      answer2: r2,
      answer3: r3,
      answer4: r4,
      answerfeedback: false
    }));
  }


  const handleSubmitAnswer = (e, n, next = null) => {
    // console.log("state.answer: ", state.answer, " n: ", n, " answers[n]: ", answers[n]);
    e.preventDefault();
    let af = false;
    if (singleAnswers.includes(n) && !answers[n].includes(state.answer)){
      af = "wrong";
    }
    else if (multipleAnswers.includes(n) &&
      (!answers[n][0].includes(state.answer) ||
       !answers[n][1].includes(state.answer2) ||
       !answers[n][2].includes(state.answer3) ||
       !answers[n][3].includes(state.answer4))){
      af = "wrong";
    }

    else {
      if (n == "room2a" || n == "room2b" || n == "room3a" ||  n == "room4a") {

        let timer1 = setTimeout(function() {
          handleChangeStep(next+1)
        }, 2000);

        af = "right";
      }
      else if(n == "room1" ||  n == "room2c" || n == "room3b" || n == "room4b" || n == "room5" || n == "room6"){
        handleChangeStep(next+1);
        af = "right";
      }
      else{
      }
    }

    setState(prevState => ({
      ...prevState,
      answer: '',
      answer2: '',
      answer3: '',
      answer4: '',
      answerfeedback: af
    }));


  }

  const handleChangeRoom = (i) => {
    if (i === null || i === undefined) i = state.room + 1;
    else if (i === -1 && state.room > 0) i = state.room - 1;
    else if (i === -1 && state.room <= 0) i = 0;

    //console.log("updateState: room: ", i, " step: ", 0);

    if(state.uuid !== '' && state.waitingApi === false && state.endtime === 0){
      setState(prevState => ({
        ...prevState,
        waitingApi: true
      }));
      updateState(state.uuid, i, 0, state.penality).then(response => {
        setState(prevState => ({
          ...prevState,
          waitingApi: false
        }));
      });
    }

    setState(prevState => ({
      ...prevState,
      room: i,
      step: 0,
      stepnow: 0,
      helpstate: 0,
      helpopen: 0
    }));
  }

  const handleChangeStep = (i = null) => {
    setState(prevState => ({
      ...prevState,
      // waitingApi: true,
      answerfeedback: false
    }));

    if (i === null || i === undefined) i = state.stepnow +1; // se non è settato incremento di 1
    else if(i === -1 && state.stepnow > 0) i = state.stepnow - 1; // se provo a decrementare (tramite debug) e non sono al primo step decremento
    else if(i === -1 && state.stepnow <= 0) i = 0; // se provo a decrementare (tramite debug) e  sono al primo step rimango al primo step

    let l;
    if (state.step > i) {
      l = state.step; // se ho raggiunto in precedenza uno step maggiore di quello che cerco di impostare lascio step invariato e modifico solo stepnow
      // setState(prevState => ({
      //   ...prevState,
      //   waitingApi: false
      // }));
    }
    else {
      l = i;
      // updateState(state.uuid, state.room, l).then(response => { // faccio l'update con step
      //   setState(prevState => ({
      //     ...prevState,
      //     waitingApi: false
      //   }));
      // });
    }

    //updateState(state.uuid, state.room, i); // faccio l'update con stepnow
    setState(prevState => ({
      ...prevState,
      step: l,
      stepnow: i,
    }));
  }

  const handleStartGame = () => {

    //e.preventDefault();
    if(state.nick === '' || state.ticket === '' ){
      setState(prevState => ({
        ...prevState,
        loginfeedback: "empty",
        nick: '',
        ticket: ''
      }));
      return;
    }

    setState(prevState => ({
      ...prevState,
      waitingApi: true
    }));

    if (state.ticket === 'must22'){
      setState(prevState => ({
        ...prevState,
        room: 1,
        waitingApi: false,
        ticket: '',
        nick: '',
        starttime: new Date().getTime(),
        endtime: 0
      }));
    }

    // else if(!state.ticket.startsWith("ESP2022") && state.ticket !== 'EBE0811MH00065'){
    //   setState(prevState => ({
    //     ...prevState,
    //     waitingApi: false,
    //     loginfeedback: "code",
    //     nick: '',
    //     ticket: ''
    //   }));
    //   return;
    // }

    else{
      startGame(state.ticket)
        .then(response => {
          console.log("res: ", response);
            if(response.data && response.data.status === 'start_game') {
              const startRoom = (response.data.room === 0 || response.data.room === null) ? 1 : response.data.room; // FIX MOMENTANOEO PER BUG 19nov16.15 Generate Game Sessione con codice Vivaticket mi torna null
              setState(prevState => ({
                ...prevState,
                uuid: response.data.uuid,
                room: startRoom,
                step: response.data.step,
                stepnow: response.data.step,
                waitingApi: false,
                ticket: '',
                nick: '',
                starttime: new Date(Date.now() - response.data.time*1000),
                endtime: 0,
                penality: response.data.penalty,
              }));

              updateState(response.data.uuid, startRoom, response.data.step, response.data.penalty); // setto la room a 1
              setNickname(response.data.uuid, state.nick)
            }
            else{
              //console.log('not valid');
              setState(prevState => ({
                ...prevState,
                ticket: '',
                nick: '',
                loginfeedback: "code",
                waitingApi: false
              }));
            }
        });
      }
  }

  const handleChangeTicket = (e) => {
      let ticket;
      if (e.target.name === 'code') {
          ticket = e.target.value;
      }
      setState(prevState => ({
        ...prevState,
        loginfeedback: false,
        ticket: ticket
      }));
  }

  const handleChangeNick = (e) => {
      const re = /^[0-9\b]+$/;
      let result = e.target.value.replace(/[^A-Za-z0-9]/g, '');
      setState(prevState => ({
        ...prevState,
        loginfeedback: false,
        nick: result
      }));


  }


  const handleAskForHelp = (e, i = null) => {
      e.stopPropagation();
      if (i === null || i === undefined) i = state.helpstate;

      let tempArr = state.helpsused;
      let incremento_penality = (i === 1 || i === 4 || i === 7) ? 1 :
                                (i === 2 || i === 5 || i === 8) ? 2 : 3; // incremento di 1 se apro indizio 1, 2 per inidizio 2 e 3 per 3
      const p = (tempArr[state.room-1][i-1] == 0) ? state.penality + incremento_penality : state.penality;
      tempArr[state.room-1][i-1] = 1;

      setState(prevState => ({
        ...prevState,
        helpopen: i,
        penality: p,
        helpsused: tempArr
      }));
  }

  const handleNextHelp = (i = null) => {
      if (i === null || i === undefined){
        i = (state.helpstate == 3 || state.helpstate == 6 || state.helpstate == 9) ? state.helpstate : state.helpstate + 1;
      }
      setState(prevState => ({
        ...prevState,
        helpopen: 0,
        helpstate: i
      }));
  }

  const handleTimeIsOver = () => {
      handleChangeRoom(9)

      validateTicket(state.uuid, state.penality)

  }

  const handleStopTime = (time) => {
    console.log("time:", time)
      clearTimeout(intervalRef.current);
      setState(prevState => ({
        ...prevState,
        endtime: time,
      }));

      validateTicket(state.uuid, state.penality)

  }




  useEffect(() => {
    //console.log('uuid: ', uuidRef.current);
    intervalRef.current = setInterval(
      () => {
          // console.log('useEffect uuid: ',uuidRef.current, " waitRef: ", waitRef.current);
          if(uuidRef.current !== '' && waitRef.current == false){
            checkState(uuidRef.current).then(response => {
              if (response.data){
                setState(prevState => ({
                  ...prevState,
                  room: response.data.room,
                  starttime: new Date(Date.now() - response.data.time*1000),
                  // step: response.data.step, // commentato tanto non setto gli step al cambio step
                  // stepnow: response.data.step
                }));
              }
            })
          }}
      , 5000);

      return () => {
        clearTimeout(intervalRef.current);
      };
  }, []);


    return (
      <Router basename={'/'}>
        <div className="App">
          {/*(state.room > 0) && (
            <Debug penality={state.penality} helpstate={state.helpstate} helpopen={state.helpopen} room={state.room} step={state.step} stepnow={state.stepnow} onChangeRoom={handleChangeRoom} onChangeStep={handleChangeStep} />
          )*/}

          <Routes>
            <Route path="/" element={
              <>

                <Player room={state.room} step={state.step} onChangeStep={handleChangeStep} />
                {(state.room >0) && (
                  <div className='time'>
                    <Time starttime={state.starttime} penality={state.penality} onTimeIsOver={handleTimeIsOver} onStopTime={handleStopTime} room={state.room} />
                  </div>
                )}

                {(state.room === 0) && (
                  <Landing waiting={state.waitingApi} onSubmitTicket={handleStartGame} onChangeTicket={handleChangeTicket} onChangeNick={handleChangeNick} loginfeedback={state.loginfeedback} ticket={state.ticket} nick={state.nick} />
                )}
                {(state.room === 1) && (
                  <Room1 helpstate={state.helpstate} helpopen={state.helpopen} answer={state.answer} answerfeedback={state.answerfeedback} room={state.room} step={state.step} stepnow={state.stepnow} onChangeRoom={handleChangeRoom} onChangeStep={handleChangeStep} onSubmitAnswer={handleSubmitAnswer} onChangeAnswer={handleChangeAnswer} onAskForHelp={handleAskForHelp} onNextHelp={handleNextHelp} />
                )}
                {(state.room === 2) && (
                  <Room2 helpstate={state.helpstate} helpopen={state.helpopen} answer={state.answer} answerfeedback={state.answerfeedback} room={state.room} step={state.step} stepnow={state.stepnow} onChangeRoom={handleChangeRoom} onChangeStep={handleChangeStep} onSubmitAnswer={handleSubmitAnswer} onChangeAnswer={handleChangeAnswer} onAskForHelp={handleAskForHelp} onNextHelp={handleNextHelp} />
                )}
                {(state.room === 3) && (
                  <Room3 helpstate={state.helpstate} helpopen={state.helpopen} answer={state.answer} answer2={state.answer2} answer3={state.answer3} answer4={state.answer4} answerfeedback={state.answerfeedback} room={state.room} step={state.step} stepnow={state.stepnow} onChangeRoom={handleChangeRoom} onChangeStep={handleChangeStep} onSubmitAnswer={handleSubmitAnswer} onChangeAnswer={handleChangeAnswer} onAskForHelp={handleAskForHelp} onNextHelp={handleNextHelp} />
                )}
                {(state.room === 4) && (
                  <Room4 helpstate={state.helpstate} helpopen={state.helpopen} answer={state.answer} answer2={state.answer2} answer3={state.answer3} answer4={state.answer4} answerfeedback={state.answerfeedback} room={state.room} step={state.step} stepnow={state.stepnow} onChangeRoom={handleChangeRoom} onChangeStep={handleChangeStep} onSubmitAnswer={handleSubmitAnswer} onChangeAnswer={handleChangeAnswer} onAskForHelp={handleAskForHelp} onNextHelp={handleNextHelp} />
                )}
                {(state.room === 5) && (
                  <Room5 helpstate={state.helpstate} helpopen={state.helpopen} answer={state.answer} answerfeedback={state.answerfeedback} room={state.room} step={state.step} stepnow={state.stepnow} onChangeRoom={handleChangeRoom} onChangeStep={handleChangeStep} onSubmitAnswer={handleSubmitAnswer} onChangeAnswer={handleChangeAnswer} onAskForHelp={handleAskForHelp} onNextHelp={handleNextHelp} />
                )}
                {(state.room === 6) && (
                  <Room6 helpstate={state.helpstate} helpopen={state.helpopen} answer={state.answer} answerfeedback={state.answerfeedback} room={state.room} step={state.step} stepnow={state.stepnow} onChangeRoom={handleChangeRoom} onChangeStep={handleChangeStep} onSubmitAnswer={handleSubmitAnswer} onChangeAnswer={handleChangeAnswer} onAskForHelp={handleAskForHelp} onNextHelp={handleNextHelp} />
                )}
                {(state.room === 7) && (
                  <Room7 helpstate={state.helpstate} helpopen={state.helpopen} answer={state.answer} answerfeedback={state.answerfeedback} room={state.room} step={state.step} stepnow={state.stepnow} onChangeRoom={handleChangeRoom} onChangeStep={handleChangeStep} onSubmitAnswer={handleSubmitAnswer} onChangeAnswer={handleChangeAnswer} onAskForHelp={handleAskForHelp} onNextHelp={handleNextHelp} />
                )}
                {(state.room === 8) && (
                  <Room8 penality={state.penality} endtime={state.endtime} room={state.room} />
                )}
                {(state.room === 9) && (
                  <Room9 penality={state.penality} room={state.room} onChangeRoom={handleChangeRoom} />
                )}
              </>
            } />

            <Route path="/come-funziona" element={<Come />} />
            <Route path="/crediti" element={<Crediti />} />
            <Route path="/regolamento" element={<Regolamento />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/scopri" element={<Scopri />} />
            <Route path="/classifica" element={<Classifica />} />

          </Routes>

          <Footer />
        </div>
      </Router>


    );

    function Home() {
  return <h2>Home</h2>;
}

function About() {
  return <h2>About</h2>;
}
}

export default App;
